import { IconTypes } from "../icons/types";
import IconDescription from "../IconDescription";

export type HighlightItem = {
  iconName: IconTypes;
  title: string;
  subtitle: string;
  showPartnerName?: boolean;
  partnerName?: string;
};

const getDisplaySubtitle = (
  partnerName: string,
  subtitle: string,
  showPartnerName?: boolean,
): string => {
  if (showPartnerName && partnerName) {
    return `${subtitle} ${partnerName}.`;
  }
  return subtitle;
};

export default function HighlightsItem({
  iconName,
  title,
  subtitle,
  showPartnerName = false,
  partnerName,
}: HighlightItem) {
  return (
    <IconDescription
      iconType={iconName}
      title={title}
      subtitle={getDisplaySubtitle(
        partnerName || "",
        subtitle,
        showPartnerName,
      )}
      variant="vertical"
      textColor="text-elm-500"
      subtitleClassname="text-gray-800 text-base"
      svgProps={{
        width: "48",
        height: "48",
        className: "text-elm-500 fill-current",
      }}
    />
  );
}
